import Home from "./componants/Home/Home";
import Navbar from "./componants/Navbar/Navbar";
import About from "./componants/About/About";
import Portfolio from "./componants/Portfolio/Portfolio";
import Contact from "./componants/Contact/Contact";
import Footer from "./componants/Footer/Footer";
import BackToTop from "./componants/BackToTop/BackToTop";
import TempSkill from "./componants/TempSkills/TempSkill";
import Experience from "./componants/Experience/Experience";

import "./App.css";

function App() {
  return (
    <>
      <Navbar />
      <main>
        <Home />
        <About />
        <TempSkill />
        <Portfolio />
        <Experience />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}

export default App;
